import { render, staticRenderFns } from "./PlaceAlmostClosedNotice.vue?vue&type=template&id=6dafee0d&"
import script from "./PlaceAlmostClosedNotice.vue?vue&type=script&lang=ts&"
export * from "./PlaceAlmostClosedNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports